import * as React from "react";
import { Path, Rect, G, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const CGIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="CG" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#FA1111"
        fillRule="evenodd"
        d="M16 0v12H0L16 0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#07A907"
        fillRule="evenodd"
        d="M0 12V0h16L0 12Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FBCD17"
        fillRule="evenodd"
        d="M14.746-2.9-.5 11.788l3.026 1.506L17.32-.106 14.746-2.9Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={19}
        height={17}
        x={-1}
        y={-3}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M14.746-2.9-.5 11.788l3.026 1.506L17.32-.106 14.746-2.9Z"
          clipRule="evenodd"
        />
      </Mask>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
